import { Bug, Lightbulb, HelpCircle, CreditCard, Shield, MoreHorizontal } from 'lucide-react'

const CATEGORY_MAP: Record<string, { icon: React.ReactNode; label: string }> = {
  bug: { icon: <Bug className="w-4 h-4" />, label: 'Bug Report' },
  feature: { icon: <Lightbulb className="w-4 h-4" />, label: 'Feature Request' },
  'how-to': { icon: <HelpCircle className="w-4 h-4" />, label: 'Question' },
  billing: { icon: <CreditCard className="w-4 h-4" />, label: 'Billing' },
  security: { icon: <Shield className="w-4 h-4" />, label: 'Security' },
  other: { icon: <MoreHorizontal className="w-4 h-4" />, label: 'Other' },
}

export function CategoryIcon({ category, showLabel }: { category: string; showLabel?: boolean }) {
  const config = CATEGORY_MAP[category] || CATEGORY_MAP.other
  return (
    <span className="inline-flex items-center gap-1 text-gray-500">
      {config.icon}
      {showLabel && <span className="text-xs">{config.label}</span>}
    </span>
  )
}
